// mantine
import { Table } from '@mantine/core';
// components
import { IFlow } from '@newo/api/gateway';
import FlowRow from '@/pages/Agents/components/FlowsTable/components/FlowRow';
// utils
import { cn } from '@/utils';

interface FlowsTableProps {
    className?: string;
    flows: IFlow[];
}

const FlowsTable = ({ className, flows }: FlowsTableProps) => {
    return (
        <div
            className={cn(
                'rounded-lg border border-solid border-gray-3',
                className
            )}
        >
            <Table highlightOnHover>
                <Table.Thead>
                    <Table.Tr>
                        <Table.Th className="w-1/5">Name</Table.Th>
                        <Table.Th className="w-1/4">Description</Table.Th>
                        <Table.Th>Created</Table.Th>
                        <Table.Th>Updated</Table.Th>
                        <Table.Th>Published</Table.Th>
                        <Table.Th>Status</Table.Th>
                        <Table.Th className="text-right">Actions</Table.Th>
                    </Table.Tr>
                </Table.Thead>
                <Table.Tbody className="[&>tr:last-child]:border-b-0!">
                    {flows.map((flow) => (
                        <FlowRow flow={flow} key={flow.idn} />
                    ))}
                </Table.Tbody>
            </Table>
        </div>
    );
};

export default FlowsTable;
